/**
 * 信息提示动画
 */
import fvAnimation from "./fvAnimation"
export default class fvMessage extends fvAnimation {
    constructor(shape){
        super(shape,"fvMessage");
        this.sizeFunction = AsyncFunction("return " + this.expression);
    }

    async run(canvas,value){
        if(value == false) return;
        var size = await this.executionScript(this.sizeFunction);
        if(this.shape.mouseState){
            if(this.shape.toolTip == false || this.shape.toolTip == undefined){
                this.shape.toolTip = true;
                setTimeout(()=>{
                    if(this.shape.system){
                        this.shape.system.tooltip.$.show(true,event,size);
                    }else{
                        this.shape.fvSystemApi.system.tooltip.$.show(true,event,size);
                    }
                },this.delayTime)
            }else{
                if(this.shape.system){
                    this.shape.system.tooltip.$.move(event);
                }else{
                    this.shape.fvSystemApi.system.tooltip.$.move(event);
                }
            }
        }else{
            if(this.shape.toolTip){
                this.shape.toolTip = false;
                setTimeout(()=>{
                    if(this.shape.system){
                        this.shape.system.tooltip.$.show(false,event,size);
                    }else{
                        this.shape.fvSystemApi.system.tooltip.$.show(false,event,size);
                    }
                },this.thatTime)
            }
        }
        super.run();
      }

}



// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvMessage.js